import {
  SETTINGS_PUNCH_LIST_PRIORITY_CLEAR_SNACKBAR,
  SETTINGS_GET_PUNCH_LIST_PRIORITY,
  SETTINGS_GET_PUNCH_LIST_PRIORITY_LOADING,
  SETTINGS_DELETE_PUNCH_LIST_PRIORITY_SUCCESS,
  SETTINGS_ADD_PUNCH_LIST_PRIORITY_SUCCESS,
  SETTINGS_ADD_PUNCH_LIST_PRIORITY_ERROR,
  SETTINGS_PUNCH_LIST_PRIORITY_ERROR,
} from "../constants/types";

const initialState = {
  punchListPriority: [],
  loading: true,
  status: "success",
  text: "",
  showSnackbar: false,
};

const punchListPriorityReducer = (state = initialState, action) => {
  switch (action.type) {
    case SETTINGS_PUNCH_LIST_PRIORITY_CLEAR_SNACKBAR:
      return {
        ...state,
        showSnackbar: false,
      };
    case SETTINGS_GET_PUNCH_LIST_PRIORITY:
      return {
        ...state,
        ...action.payload,
        showSnackbar: false,
      };
    case SETTINGS_GET_PUNCH_LIST_PRIORITY_LOADING:
      return {
        ...state,
        loading: true,
      };
    case SETTINGS_DELETE_PUNCH_LIST_PRIORITY_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case SETTINGS_ADD_PUNCH_LIST_PRIORITY_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case SETTINGS_ADD_PUNCH_LIST_PRIORITY_ERROR:
      return {
        ...state,
        ...action.payload,
      };
    case SETTINGS_PUNCH_LIST_PRIORITY_ERROR:
      return {
        ...state,
        loading: false,
        status: action.payload.status,
        text: action.payload.text,
        showSnackbar: true,
      };

    default:
      return state || {};
  }
};

export default punchListPriorityReducer;
